import { Pipe, PipeTransform } from '@angular/core';
import { ShiftType } from '../../models';

@Pipe({
  name: 'shiftTypeFilter'
})
export class ShiftTypeFilterPipe implements PipeTransform {

  transform(values: ShiftType[], args?: string): any {

    if (!args) {
      return values;
    }

    return values.filter(item => item.name.toLowerCase().startsWith(args.toLowerCase()))
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/pipes/shift-type-filter.pipe.ts